import { render } from "./SpecialRequestForm.vue?vue&type=template&id=6fd390be"
import script from "./SpecialRequestForm.vue?vue&type=script&lang=js"
export * from "./SpecialRequestForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__